export default "__VITE_ASSET__HEd37BO4__"